export const SYNC_SIZE = 'sync-size';
export const FULLSCREEN_EVENT = 'fullscreen-event';
export const VIDEO_PAUSE_EVENT = 'video-pause-event';
export const VIDEO_PLAY_EVENT = 'video-play-event';
export const VIDEO_SEEKING_EVENT = 'video-seeking-event';
